import { type FormDefinitionResponse } from 'app/modules/FormDefinition/models/definition.types';
import { type SectionComment } from 'app/modules/Reports/TaxReturnList/types';

import { type RejectTaxReturnDto } from './types';

export const createFormComments = (formDefinition: FormDefinitionResponse): RejectTaxReturnDto => {
  const result = { sections: new Array<SectionComment>() } as RejectTaxReturnDto;
  if (formDefinition) {
    formDefinition.sections.forEach((x) => {
      result.sections.push({ sectionName: x.name, comment: '' });
    });
  }
  return result;
};
